Ext.define('SA.view.sidebar.data.DataSearchNoResults', {
    alias: 'widget.data-search-no-results',
    extend: 'Ext.Component',

    cls: 'sa-data-search-no-results',

    renderTpl: [
        '<svg class="sa-data-search-no-results-svg"><use href="#sa-icon-warning"></use></svg>',
        '<div class="sa-data-search-no-results-text">{text:htmlEncode}</div>'
    ],

    beforeRender() {
        this.callParent();

        this.renderData = {...this.renderData, text: this.text};
    }
});